import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";
import { getNutritionTargetsForPlanDay } from "../../../../../utils/nutrition-helpers";

function PlanNutritionCard({ nutritionPlans, dayKey, exercises }) {
  const { t } = useTranslation(["athlete-portal", "common"]);
  const target = getNutritionTargetsForPlanDay(
    nutritionPlans,
    dayKey,
    exercises
  );
  if (!target) return null;

  return (
    <div className="plan-card plan-card--nutrition">
      <div className="plan-card__header">
        <SvgIcon src="/img/new-icons/nutrition.svg" useCurrentColor={true} />
        {t("calendar.cards.nutrition.title")}
        <span className="ml-auto text-(--white) font-normal text-[0.65rem]">
          {target.calories} {t("common:units.kcalAbbr")}
        </span>
      </div>
      <div className="plan-card__macro-row">
        <span className="macro-pill macro-pill--protein">
          <span className="macro-pill__letter">
            {t("common:macros.proteinAbbr")}
          </span>
          {target.proteins}
        </span>
        <span className="macro-pill macro-pill--carbs">
          <span className="macro-pill__letter">
            {t("common:macros.carbsAbbr")}
          </span>
          {target.carbs}
        </span>
        <span className="macro-pill macro-pill--fat">
          <span className="macro-pill__letter">
            {t("common:macros.fatAbbr")}
          </span>
          {target.fats}
        </span>
      </div>
    </div>
  );
}

export default PlanNutritionCard;
